import { render, staticRenderFns } from "./SearchProperties.vue?vue&type=template&id=839214f4&"
import script from "./SearchProperties.vue?vue&type=script&lang=js&"
export * from "./SearchProperties.vue?vue&type=script&lang=js&"
import style0 from "./SearchProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports